import environment from './environment';

// Configuración de la API
const API_CONFIG = {
  // URL base del backend - se detecta automáticamente el entorno
  BASE_URL: environment.apiUrl,
  
  // Endpoints específicos
  ENDPOINTS: {
    // Autenticación
    AUTH: {
      BASE: '/auth',
      LOGIN: '/auth/login',
      LOGOUT: '/auth/logout',
      VERIFY: '/auth/verify',
      CHANGE_PASSWORD: '/auth/change-password'
    },
    
    // 2FA
    TWO_FA: {
      BASE: '/2fa',
      SETUP: '/2fa/setup-2fa',
      VERIFY_LOGIN: '/2fa/verify-2fa-login',
      VERIFY_ACTIVATE: '/2fa/verify-2fa-activate'
    },
    
    // Cuentas
    CUENTAS: {
      BASE: '/cuentas',
      CREAR_PERSONAL: '/cuentas/crear-personal',
      CREAR_EMPRESARIAL: '/cuentas/crear-empresarial',
      PROVINCIAS: '/cuentas/provincias',
      CIUDADES: '/cuentas/ciudades'
    },
    
    // Contactos
    CONTACTOS: {
      BASE: '/contactos'
    },
    
    // Oportunidades
    OPORTUNIDADES: {
      BASE: '/oportunidades',
      STAGENAMES: '/oportunidades/stagenames',
      ORIGEN_PROSPECTO: '/oportunidades/origen-prospecto',
      BY_ID: '/oportunidades/:id',
      BY_ACCOUNT: '/oportunidades/account/:accountId'
    },
    
    // Presupuestos
    PRESUPUESTOS: {
      BASE: '/presupuestos',
      PRODUCTOS: '/presupuestos/productos',
      SERVICIOS: '/presupuestos/servicios'
    },
    
    // Prospectos
    PROSPECTOS: {
      BASE: '/prospectos',
      REGISTRAR: '/prospectos/registrar'
    },
    
    // Tareas
    TAREAS: {
      BASE: '/tareas',
      BY_ACCOUNT: '/tareas/account/:accountId',
      UPDATE_STATUS: '/tareas/:id/status'
    },
    
    // Documentos
    DOCUMENTS: {
      BASE: '/documents',
      UPLOAD: '/documents/upload'
    },
    
    // Datos
    DATA: {
      PROVINCIAS: '/data/provincias',
      CIUDADES: '/data/ciudades',
      PROSPECTO_ORIGEN: '/data/prospectoorigen'
    },
    
    // Usuarios
    USUARIOS: {
      BASE: '/usuarios',
      CREAR: '/usuarios/crear'
    },
    
    // Roles
    ROLES: {
      BASE: '/roles',
      LISTAR: '/roles'
    },
    
    // Seguridad
    SECURITY: {
      BASE: '/security',
      STATS: '/security/stats',
      ALERTS: '/security/alerts'
    },

    // Relevos
    RELEVOS: {
      BASE: '/relevos',
      STATUS: '/relevos/status',
      APERTURA: '/relevos/apertura',
      CIERRE: '/relevos/cierre',
      CONTROL: '/relevos/control',
      TURNO_ACTUAL: '/relevos/turno-actual',
      CUBRIDORES: '/relevos/cubridores',
      ASIGNAR_CUBRIDOR: '/relevos/asignar-cubridor'
    },

    // Bitácora
    BITACORA: {
      BASE: '/bitacora',
      STATUS: '/bitacora/status',
      REGISTRAR_EVENTO: '/bitacora/evento',
      LISTAR_EVENTOS: '/bitacora/eventos',
      EXTRACT_CEDULA: '/bitacora/extract-cedula',
      CONSULTAR_EVENTOS: '/bitacora/eventos/consulta',
      LISTAR_VISITANTES: '/bitacora/visitantes',
      REGISTRAR_SALIDA_VISITANTE: '/bitacora/visitantes/salida',
      LISTAR_VEHICULOS: '/bitacora/vehiculos',
      REGISTRAR_SALIDA_VEHICULO: '/bitacora/vehiculos/salida',
      LISTAR_VEHICULOS_INSTITUCIONALES_SALIDA: '/bitacora/vehiculos-institucionales/salida',
      REGISTRAR_RETORNO_VEHICULO_INST: '/bitacora/vehiculos-institucionales/retorno',
      CONFIG_FIRMA: '/bitacora/config-firma',
      CONFIG_FIRMA_VEHICULO: '/bitacora/config-firma-vehiculo',
      CONFIG_FOTO_VEHICULO: '/bitacora/config-foto-vehiculo',
      OPCIONES_PERSONALIZADAS: '/bitacora/opciones-personalizadas'
    },

    VEHICULOS: {
       BASE: '/vehiculos'
     },

    DASHBOARD: {
      BASE: '/dashboard',
      OVERVIEW: '/dashboard/overview'
    },

    // Supervisión
    SUPERVISION: {
      BASE: '/supervision',
      CONFIG: '/supervision/config',
      LISTAR_PUESTOS: '/supervision/puestos',
      LISTAR_CHECKS: '/supervision/checks',
      VIGILANTES_ACTIVOS: '/supervision/vigilantes-activos',
      BUSCAR_PERSONAL_CEDULA: '/supervision/buscar-personal-por-cedula',
      VERIFICAR_VIGILANTE_PUESTO: '/supervision/verificar-vigilante-puesto',
      ESTADO_PUESTO_PHT: '/supervision/estado-puesto-pht',
      REPORTAR_DISCREPANCIA_VIGILANTE: '/supervision/reportar-discrepancia-vigilante',
      CATALOGO_MULTAS: '/supervision/catalogo-multas',
      VALIDAR_GPS: '/supervision/validar-gps',
      VALIDAR_UBICACION_PUESTO: '/supervision/validar-ubicacion-puesto',
      REGISTRAR_ASISTENCIA: '/supervision/registrar-asistencia',
      VISITAS_REALIZADAS: '/supervision/visitas-realizadas',
      CATALOGO: '/supervision/catalogo',
      ESTADISTICAS_SUPERVISION_MES: '/supervision/estadisticas-supervision-mes',
      ESTADISTICAS_VISITAS_POR_HORA: '/supervision/estadisticas-visitas-por-hora',
      ESTADISTICAS_VISITAS_POR_HORA_DIA: '/supervision/estadisticas-visitas-por-hora-dia',
      ESTADISTICAS_PUNTOS: '/supervision/estadisticas-puntos',
      VERIFICAR_ARMAMENTO: '/supervision/verificar-armamento',
      ARMAMENTO_VERIFICAR_REGISTRAR: '/supervision/armamento-verificar-registrar',
      ARMAMENTO_ANALIZAR_IMAGEN: '/supervision/armamento-analizar-imagen',
      ARMAMENTO_REGISTRAR_CON_SERIE: '/supervision/armamento-registrar-con-serie',
      PUESTOS_ARMAMENTO: '/supervision/puestos-armamento',
      MULTAS_CERTIFICADO_SUBIR: '/supervision/multas-certificado-subir',
      PERSONAL_CERTIFICADO_LISTA: '/supervision/personal-certificado-lista',
      SANCIONES_CONFIG: '/supervision/sanciones-config',
      SANCIONES_PERSONAL_LISTA: '/supervision/sanciones-personal-lista',
      SANCIONES_LUGAR_PREVIEW: '/supervision/sanciones-lugar-preview',
      SANCIONES_REGISTRAR: '/supervision/sanciones-registrar',
      MULTAS_CERTIFICADO_CONSULTA: '/supervision/multas-certificado-consulta',
      MULTAS_CERTIFICADO_IMAGEN: '/supervision/multas-certificado-imagen',
      JUSTIFICACION_PERIODO_LISTA: '/supervision/justificacion-periodo-lista',
      JUSTIFICACION_PERIODO_SUBIR: '/supervision/justificacion-periodo-subir',
      JUSTIFICACION_PERIODO_IMAGEN: '/supervision/justificacion-periodo-imagen',
      RUTA_PROGRAMADA_ESTADO: '/supervision/ruta-programada/estado',
      RUTA_PROGRAMADA_TIMBRAR: '/supervision/ruta-programada/timbrar',
      RUTA_PROGRAMADA_RESUMEN_SEMANAL: '/supervision/ruta-programada/resumen-semanal',
      RUTA_PROGRAMADA_MIS_ASIGNACIONES: '/supervision/ruta-programada/mis-asignaciones'
    },

    // Alertas vigilancia nocturna (CAPTCHA / push)
    RONDA_OFFLINE: {
      BASE: '/ronda-offline',
      ESTADO: '/ronda-offline/estado',
      INICIAR: '/ronda-offline/iniciar',
      FINALIZAR: '/ronda-offline/finalizar'
    },

    ALERTA_VIGILANCIA: {
      BASE: '/alerta-vigilancia',
      FCM_TOKEN: '/alerta-vigilancia/fcm-token',
      BY_ID: '/alerta-vigilancia/:id',
      VALIDAR: '/alerta-vigilancia/:id/validar',
      ADMIN_STATUS: '/alerta-vigilancia/admin/status',
      ADMIN_REENVIAR: '/alerta-vigilancia/admin/reenviar'
    }
  }
};

// Función helper para construir URLs completas
export const buildApiUrl = (endpoint) => {
  return `${API_CONFIG.BASE_URL}${endpoint}`;
};

// Función helper para obtener URLs de endpoints específicos
export const getApiUrl = (category, endpoint) => {
  const endpointPath = API_CONFIG.ENDPOINTS[category]?.[endpoint];
  if (!endpointPath) {
    throw new Error(`Endpoint no encontrado: ${category}.${endpoint}`);
  }
  return buildApiUrl(endpointPath);
};

// Exportar la configuración completa
export default API_CONFIG;
